module.exports = __webpack_public_path__ + "static/media/bitbucket.8bbf86e9.png";